import { routeGroup } from '#/routing/routes';

export const orgDashboardBuyCreditsLinksRoute = routeGroup.route('buy-credits');

export const orgDashboardCreditsLinksRoute = routeGroup.route('credits');

export const orgDashboardIntegrateAtsLinksRoute =
  routeGroup.route('integrate-ats');

export const orgDashboardAdminsLinksRoute = routeGroup.route('admins');

export const orgDashboardEditOrgLinksRoute = routeGroup.route('edit-org');

export const orgDashboardGradfairsLinksRoute = routeGroup.route('gradfairs');

export const orgDashboardInvoicesLinksRoute = routeGroup.route('invoices');

export const orgDashboardMembershipLinksRoute = routeGroup.route('membership');
